import React, { useEffect, useState, useCallback } from 'react';
import classnames from 'classnames'
import { ajax, apicRoot } from '@liepin/js-core4c-fe';
import { useSearchJob } from '@liepin/react-framework4c-pc/src/hooks';
import SearchInput from '../SearchInput';
import styled from './index._less';
import hotless from './hot._less';
import { ESearchKeyType } from '../types';

interface IProp {
  qrcode?: string, // 搜索条右侧二维码（每个场景埋点不一样）
  openNewWindow?: boolean, // 是否新窗口打开链接
  simple?: boolean, // 简版搜索条（目前使用场景：www首页悬停时）
  showHot?: boolean, // 是否显示热词,
  onClick?: (keyword?: string, keyType?: ESearchKeyType) => void, // openNewWindow为false时的回调
}

const SearchBar: React.FC<IProp> = ({ qrcode, openNewWindow = true, simple = false, showHot = true, onClick }: IProp) => {
  const [hotWordList, setHotWordList] = useState([]);

  const { getSearchURL } = useSearchJob({ checkCity: false });

  useEffect(() => {
    ajax({
      url: `${apicRoot}/api/com.liepin.searchfront4c.pc-hot-search-word-list`,
    }).then(({ data }) => {
      setHotWordList(data);
    }).catch(() => {});
  }, []);

  const handleClickedHotword = useCallback((word) => {
    const key = encodeURIComponent(word);
    if (openNewWindow) {
      window.open(`${getSearchURL()}&key=${key}`, '_blank');
    } else {
      onClick?.(key, ESearchKeyType.HotWord);
    }
  }, [getSearchURL, openNewWindow]);

  const handleClickedSearch = useCallback((word) => {
    const key = encodeURIComponent(word);
    if (openNewWindow) {
      window.open(`${getSearchURL()}&key=${key}`, '_blank');
    } else {
      onClick?.(key, ESearchKeyType.Input);
    }
  }, [getSearchURL]);

  const renderHot = useCallback(() => {
    if (hotWordList.length === 0 || !showHot) {
      return null;
    }

    return (
      <>
        <div className="search-bar-hot-word">
          <div>热搜:</div>
          {
            hotWordList?.map((item, i) => {
              return (
                <span className="search-bar-hot-word-item" key={item} onClick={ () => handleClickedHotword(item) }>
                  { item }
                </span>
              )
            })
          }
        </div>
        <style jsx>{hotless}</style>
      </>
    )
  }, [hotWordList, onClick, showHot]);

  return (
    <div
      className={
        classnames('search-container', simple ? 'search-container-simple' : '')
      }
    >
      {
        qrcode ? (
          <div className="search-bar">
            <div>
              <SearchInput
                openNewWindow={openNewWindow}
                onClick={handleClickedSearch}
              />
              {renderHot()}
            </div>
            <div className="search-bar-qrcode">
              <img src={qrcode} alt="" />
            </div>
          </div>
        ) : (
          <div className="no-qrcode-search-bar">
            <SearchInput
              openNewWindow={openNewWindow}
              onClick={handleClickedSearch}
            />
            {renderHot()}
          </div>
        )
      }
      <style jsx>{styled}</style>
    </div>
  )
}

export default SearchBar;
